<template>
  <div class="cd-user-area">
    <UserSideMenuV1 id="user-sidebar" />
    <div v-if="cdUserAvailable" class="cd-user-header">
      <div style="display: flex; align-items: center; width: 100%">
        <div style="width: 30px; height: 30px; margin-right: 8px">
          <img
            v-if="profileImageSrc"
            :src="profileImageSrc"
            alt="User Avatar"
            class="profile-image"
            style="width: 100%; height: 100%; object-fit: cover; border-radius: 50%"
          />
          <div v-else class="avatar-placeholder" style="width: 100%; height: 100%; background-size: 25px"></div>
        </div>
        <div class="data" style="display: flex">
          <div class="cd-user-name">{{ currentUser }}</div>
          <svg
            class="svg-inline--fa fa-caret-down fa-w-10"
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="caret-down"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 320 512"
            data-fa-i2svg=""
            style="color: white"
          >
            <path
              fill="currentColor"
              d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
            ></path>
          </svg>
        </div>
      </div>

      <!-- User Pullout Side menu -->
    </div>
  </div>
</template>

<script lang="ts">
import { AppModule } from "@/core/store/modules/app-module";
import { ICDUserDto } from "@/core/models/CDIdentityModels";
import { CDIdentityModule } from "@/core/store/modules/cd-identity-module";
import isEmpty from "lodash/isEmpty";
import UserSideMenuV1 from "@/core/views/designlanguage/v1/UserSideMenuV1.vue";
import { defineComponent } from "vue";
import { discoveryService } from "@/core/services/DiscoveryService";

export default defineComponent({
  name: "UserAreaV1",
  components: {
    UserSideMenuV1
  },
  data() {
    return {
      profileImageSrc: ""
    };
  },
  computed: {
    currentUser(): string {
      return AppModule.config.currentUser?.name ?? "";
    },

    cdUser(): ICDUserDto {
      return CDIdentityModule.cdUser;
    },

    cdUserAvailable(): boolean {
      return !isEmpty(this.cdUser);
    },

    cdUserPhoto(): string {
      return CDIdentityModule.cdUser?.photoBase64 || "";
    }
  },
  methods: {
    arrayBufferToBase64(buffer: ArrayBuffer): string {
      let binary = "";
      const bytes = new Uint8Array(buffer);
      const len = bytes.byteLength;
      for (let i = 0; i < len; i++) {
        binary += String.fromCodePoint(bytes[i]);
      }
      return globalThis.btoa(binary);
    },
    async fetchProfileImage(userId: string) {
      try {
        const { data, contentType } = await discoveryService.getUserProfilePicture(userId);
        if (data && contentType) {
          const base64 = this.arrayBufferToBase64(data);
          this.profileImageSrc = `data:${contentType};base64,${base64}`;
        } else {
          this.profileImageSrc = "";
        }
      } catch (error) {
        console.log("Error fetching profile image:", error);
        this.profileImageSrc = "";
      }
    }
  },
  async mounted() {
    const userId = this.cdUser.id;
    if (userId) {
      await this.fetchProfileImage(userId);
    }
  }
});
</script>
<style scoped>
.cd-user-area {
  display: flex;
  flex-direction: column;
  margin-left: 0 !important;
}
</style>
